import { Box } from '@mui/material'
import { PageProps } from './Page.types'

export const Page = (props: PageProps) => {
  const { children, center } = props

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 'auto',
        padding: '36px',
        minWidth: 0,
        overflow: 'hidden',
        ...(center ? { justifyContent: 'center', alignItems: 'center' } : {}),
      }}
    >
      {children}
    </Box>
  )
}
